import React from 'react';
import {StaticImageData} from 'next/image';

import {StyledImage} from './styles';

type IconProps = {
    src: StaticImageData;
    width?: number;
    height?: number;
};

const Icon = ({src, width = 16, height = 16}: IconProps) => {
    return (
        <StyledImage
            src={src}
            width={width}
            height={height}
            alt="dome"
            layout="fixed"
        />
    );
};

export default Icon;
